import {useContext,useState} from 'react'
import { NavLink , Link } from "react-router-dom";
import { BackIndex } from '../../context/BackIndex';
import data from '../../card/effect3.json'
import fhoto from '../../view/Hd-Backgrounds.jpg'
import { CopyToClipboard } from "react-copy-to-clipboard";
import './navIn.css'

export function NavIn({props}){
  const {indexNav , setIndexNav} = useContext(BackIndex) 
  const linkNone = {textDecoration:"none"}
  const [ copy, setCopy ] = useState("Copy");
  
  function chek() {
      if ( copy === "Copy" ) {
        setCopy("Copied");
      } else if ( copy === "Copied" ) {
        setCopy("Very good!!");
      } else {
        setCopy("Copied");
      }
  }

  return(
    <>
      <nav className="containerNav" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} >
        <div className="containerLogo">
          <ul style={{display:"flex"}}>
            <NavLink to={"/"} onClick={()=>{setIndexNav("/Super")}} ><img src={fhoto} alt="Logo"/> </NavLink> 
          </ul>
        </div>  
        <div className="containerList" >
          <ul>
            <CopyToClipboard text={`https://coronadosdelbien.com/Super/${props.slug}`}>
              <button lang="en" className="NavButton" onClick={() => {chek()}}><li>URL {copy}</li></button>
            </CopyToClipboard>
            <Link to={"https://www.musicaar.com"} style={linkNone} target='_blank' > <li >UNIRME</li> </Link>
            <NavLink to={"/Sobre-esta-web"} style={linkNone}> <li>SOBRE ESTA WEB</li> </NavLink>
            <NavLink to={indexNav} style={linkNone}><li>ATRAS</li></NavLink>
          </ul>
        </div>
      </nav>    
    </>
  )
}


export function NavIn2() {
  const {index ,setIndexNav } = useContext(BackIndex) 
   const linkNone = {textDecoration:"none"}
  return (
    <>
      <nav className="containerNav" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} >
        <div className="containerLogo">
          <ul>
            <NavLink to={"/"} onClick={()=>{setIndexNav("/Super")}} ><img src={fhoto} alt="Logo"/></NavLink> 
          </ul>
        </div>  
        <div className="containerList2" >
          <ul>
            <Link to={"https://www.musicaar.com"} style={linkNone} target='_blank'><li>UNIRME</li></Link>
            <NavLink to={`/Super/${data[index - 1].slug}`} style={linkNone} ><li>ATRAS</li></NavLink>
          </ul>
        </div>
      </nav>    
    </>
  )
}

export function NavIn3() {
  const linkNone = {textDecoration:"none"}
  return (
    <>
      <nav className="containerNav" id='container' style={{ userSelect: 'none', WebkitUserSelect: 'none'}} >
        <div className="containerLogo">
          <ul >
            <NavLink style={linkNone} to={"/"}><li>INICIO</li></NavLink> 
          </ul>
        </div>  
      </nav>    
    </>
  )
}

